import React from 'react'
import { Card, Stack, Typography } from '@mui/material';

const StatCard = ({ label, value, Icon, emphasize }) => {
  return (
        <Card
            elevation={0}
            sx={{
                flex: 1,
                minWidth: 140,
                px: 2.25,
                py: 1.75,
                borderRadius: 2,
                bgcolor: emphasize ? "#00C9DB" : "rgba(255,255,255,0.06)",
                border: emphasize ? "none" : "1px solid rgba(255,255,255,0.08)",
            }}
        >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ color: emphasize ? "#003C59" : "rgba(255,255,255,0.85)", mb: 0.75 }}>
                <Icon sx={{ fontSize: 18 }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {label}
                </Typography>
            </Stack>
            <Typography variant="h4" sx={{ color: emphasize ? "#003C59" : "#fff", fontWeight: 700, lineHeight: 1 }}>
                {value}
            </Typography>
        </Card>
    );
}

export default StatCard